import { render } from "./PropertyAddToCart.vue?vue&type=template&id=42158f56&scoped=true"
import script from "./PropertyAddToCart.vue?vue&type=script&lang=js"
export * from "./PropertyAddToCart.vue?vue&type=script&lang=js"

import "./PropertyAddToCart.vue?vue&type=style&index=0&id=42158f56&lang=scss&scoped=true"
import "./PropertyAddToCart.vue?vue&type=style&index=1&id=42158f56&lang=scss"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42158f56"]])

export default __exports__